import React from "react";
import { Card, CardContent, CardFooter, CardTitle } from "@ui/card";
import { ExtraProps } from "@modules/content/components";

interface BookCardProps {
  image: string;
  title: string;
  writer: string;
  onClick?: () => void;
  isLockedContent?: boolean;
  extraProps?: ExtraProps;
}

const BookCard = ({
  image,
  title,
  writer,
  onClick,
  isLockedContent,
  extraProps,
}: BookCardProps) => {
  return (
    <Card
      className="cursor-pointer border-none bg-transparent"
      onClick={onClick}
    >
      <CardContent className="relative h-[200px] w-[200px] p-0">
        <img src={image} alt="None" className="h-full w-full rounded-md" />
        {isLockedContent ? (
          <div className="absolute bottom-[11px] left-[15px] flex h-[31px] w-[31px] items-center justify-center rounded-full bg-[linear-gradient(180deg,_rgba(255,_204,_101,_0.90)_0%,_rgba(255,_191,_62,_0.95)_100%)]">
            <img src="/assets/icons/premium.svg" alt="premium" className="" />
          </div>
        ) : null}
      </CardContent>
      <CardTitle>
        <div
          className={`p-2 text-[20px] ltr:text-left rtl:text-right ${
            extraProps?.titleClassName
              ? extraProps.titleClassName
              : "dark:text-white"
          }`}
        >
          {title}
        </div>
      </CardTitle>
      {writer ? (
        <CardFooter className="px-2 pb-0">
          <div className="text-[12px] text-[#898A8D] ltr:text-left rtl:text-right">
            {writer}
          </div>
        </CardFooter>
      ) : null}
    </Card>
  );
};

export default BookCard;
